import { render, staticRenderFns } from "./new-aboutus.vue?vue&type=template&id=982aa3ca&scoped=true"
import script from "./new-aboutus.vue?vue&type=script&lang=js"
export * from "./new-aboutus.vue?vue&type=script&lang=js"
import style0 from "./new-aboutus.vue?vue&type=style&index=0&id=982aa3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982aa3ca",
  null
  
)

export default component.exports